module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('table', {
    staticClass: "chapter-title-corner-decorations",
    attrs: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "chapter-title-corner-decoration-left-column"
  }, [_c('div', {
    staticClass: "chapter-title-corner-decoration-left-column"
  }, [_c('img', {
    staticClass: "chapter-title-corner-decoration-left",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_corner_decoration_left.png"
    }
  })])]), _c('td', {
    staticClass: "chapter-title-corner-decoration-middle-column"
  }), _c('td', {
    staticClass: "chapter-title-corner-decoration-right-column"
  }, [_c('div', {
    staticClass: "chapter-title-corner-decoration-right-column"
  }, [_c('img', {
    staticClass: "chapter-title-corner-decoration-right",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_corner_decoration_right.png"
    }
  })])])])])]), _c('div', {
    staticClass: "chapter-title"
  }, [_c('div', {
    staticClass: "chapter-title-decoration-above"
  }, [_c('div', {
    staticClass: "chapter-title-decoration-above-inner"
  }, [_c('img', {
    staticClass: "chapter-title-decoration-above",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_above.png"
    }
  })])]), _c('h1', {
    staticClass: "chapter-title"
  }, [_vm._v("Capítulo 2")]), _vm._v(" "), _c('div', {
    staticClass: "chapter-title-decoration-below"
  }, [_c('div', {
    staticClass: "chapter-title-decoration-below-inner"
  }, [_c('img', {
    staticClass: "chapter-title-decoration-below",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_below.png"
    }
  })])])]), _c('p', {
    staticClass: "first-in-chapter",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('span', {
    staticClass: "first-chapter-phrase"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("E")]), _vm._v("ra impossível para")]), _vm._v(" a Srta. Featherstone sentir a menor pontada de ciúme quando olhava para sua prima naquela noite. Como alguém poderia sentir outra coisa senão admiração ao contemplar um Da Vinci pela primeira vez? Cada ângulo da beleza de Lady Sarah era algo para se olhar pelo prazer que proporcionava. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Que visão de inocência ela apresentava com sua juventude, sua pele leitosa e imaculada e seu modesto vestido de fina musselina branca. Suas madeixas douradas caíam para trás da perfeição de seu rosto sem pintura, e um pequeno colar de pérolas agrupadas em ouro completava sua imagem de elegância simples.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Jane tinha sido atingida por tal beleza notável apenas uma vez antes. Ela se lembrou de como havia bebido da beleza de sua sobrinha mais velha na primeira vez que a viu. Bess tinha seis meses de idade a pele cremosa e mechas de cabelo loiro quando Jane a viu pela primeira vez. Ela pensou que nunca tinha visto nada mais adorável. (E, impiedosamente, ela se perguntou como Lavinia poderia ter dado à luz a alguém tão bonita).")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Foi mais ou menos o que aconteceu com Lady Sarah esta noite. Por mais adorável que ela fosse, ela se agarrou a Jane como uma criança assustada enquanto as jovens se espremiam pela porta e entravam no superlotado salão de baile de Lord Spencer.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("\"Estou muito feliz por você ter passado por isso antes.\" Lady Sarah virtualmente gritou com Jane para ser ouvida sobre o rugido de pelo menos uma centena de vozes e os acordes abafados da música da orquestra. \"Você será capaz de me dizer como agir.\"")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Devido à aglomeração de pessoas, a Srta. Featherstone não respondeu imediatamente. Elas se empurraram contra o fluxo de corpos que vinham do salão de baile. A Srta. Featherstone foi automaticamente para seu canto preferido—o mais longe possível da orquestra. \"Você não precisa de nenhuma instrução minha\", Jane disse quando chegaram ao seu destino. \"Apenas sorria e aja como faria em qualquer baile. Esqueça que este salão de baile é adornado com cortinas douradas e de seda e finja que é o salão em Stockton-on-Wye.\" ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Lady Sarah suspirou. \"Um plano excelente! Você é sempre tão inteligente.\"")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Parte da apreensão de Lady Sarah, Jane sabia, vinha do fato de que ela conhecia muito poucas das duzentas ou trezentas pessoas que estavam presentes na enorme mansão de Lord e Lady Spencer. Ela não tinha relações amigáveis com nenhuma das outras garotas que foram apresentadas a ela naquela noite.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("A Srta. Featherstone deu um tapinha no braço enluvado de sua prima. \"No final da noite, você se sentirá uma velha amiga de metade das pessoas que estão nesta sala, e os visitantes começarão a chegar em Clegg House ao meio-dia de amanhã.\"")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("\"Eu rezo para que você esteja certa.\" Lady Sarah observou os dançarinos finamente vestidos. \"Você já tropeçou e caiu enquanto dançava?\"")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("\"Não, nem nunca testemunhei tal ocorrência.\"")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("\"Eu acho isso muito reconfortante.\"")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Antes que Lady Sarah tivesse a oportunidade de se sentar em uma das cadeiras desocupadas alinhadas na parede, um exército de admiradores se lançou sobre ela e ela foi arrastada para a pista de dança. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Em seu canto, a Srta. Featherstone foi salva do isolamento humilhante pela companhia da Srta. Ophelia Lambeth. A infeliz Srta. Lambeth era tão solteirona quanto Jane. A Srta. Lambeth não era simplesmente solteirona... bem, não havia outra palavra para isso. Ela era muito "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("feia")]), _vm._v(". ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Ela era mais alta que a maioria dos homens e tinha a infelicidade de possuir um nariz que não seria tão desproporcional se estivesse em um homem de oitenta anos de grande estatura, em vez de no rosto estreito da Srta. Lambeth. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("\"Há algo de bom em se passar a maior parte do baile sentada\", disse a Srta. Featherstone a Srta. Lambeth. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("\"Você deve revelar para mim para que eu possa contar a minha mãe.\"")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("A Srta. Featherstone sorriu maliciosamente. \"Nunca precisamos nos preocupar com buracos em nossos caros sapatos de dança.\"")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("O dedo do pé coberto de cetim da Srta. Lambeth apontava por baixo de suas saias cor-de-rosa. \"Realmente. Isso me manteve em boa posição nas últimas cinco temporadas.\" Nem mesmo uma pitada de amargura tingia a voz da jovem bem-humorada.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Para que a Srta. Featherstone não fosse uma solteirona sem esperança, seu primo, Lord Harry, fez-lhe a bondade de convidá-la para dançar não uma, mas duas vezes. Quão afortunada seria a garota que um dia se casasse com o jovem atencioso.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Mais tarde naquela noite, Jane enrijeceu quando viu Lavinia entrar na sala. Ela parou e examinou o salão de baile até que viu Jane. Então, ela se dirigiu para onde Jane e a Srta. Lambeth estavam sentadas. Sem ser convidada, sentou-se ao lado da cunhada. \"Eu preciso ter uma palavra com você.\"")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Jane forçou um sorriso. \"Sobre o quê, querida?\"")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("\"Sobre sua companhia.\"")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Certamente ela não ia menosprezar a pobre Srta. Lambeth na presença da própria. \"Por favor, a quem você poderia estar se referindo?\"")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("\"Aquele seu familiar!\"")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Como Jane havia dançado recentemente com ele, ela perguntou: \"Lord Harry?\"")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("\"Claro que não! Refiro-me à irmã dele.\"")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("\"Existe algo sobre Lady Sarah que você se opõe?\"")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Com uma expressão prodigiosamente ameaçadora no rosto, Lavinia disse: \"O problema não é ela, é você\". ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("\"Esclareça-me, por favor.\"")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("\"Eu não me preocuparia se não gostasse tanto de você, querida irmã\", começou Lavinia, \"mas simplesmente não seria bom para você ser vista com alguém tão bonita quanto a sua prima! nunca vai conseguir fisgar um marido.\" ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("\"Você deve reconhecer que não consegui pegar um nestes últimos três anos. Você ainda não perdeu a esperança?\" ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("\"Rezo todos os dias para que você encontre um homem que seja um marido tão maravilhoso para você quanto seu irmão é para mim.\"")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Jane não tinha dúvidas de que a egocêntrica Lavinia realmente fazia tal oração. Não era nenhum segredo que ela não podia tolerar a ideia de ficar sobrecarregada com Jane pelo resto de sua vida.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("O olhar de Lavinia passou rapidamente por Jane e ela balançou a cabeça tristemente. \"Posso oferecer-lhe uma sugestão? Algo para o seu próprio bem?\" ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("\"Por favor.\"")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("\"Por que você não corta o cabelo? Tranças longas estão tristemente desatualizadas, e acredito que o estilo de cabelo mais curto lhe ajudaria muito.\" ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("\"Cabelo mais curto me deixaria tão bonita quanto Lady Sarah?\" Foi muito difícil para Jane conter um sorriso.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("\"Sinceramente, Jane, pensei que você fosse mais inteligente do que isso! Você nunca chegará aos pés de sua prima.\" ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("A mão cheia de joias de Lavinia enroscou-se em seus próprios cachos negros, revelando um punhado de fios grisalhos que antes estavam ocultos. “Atrevo-me a dizer que, se eu tivesse cortado o cabelo como está agora na moda, teria sido capaz de atrair pelo menos um conde quando fui apresentada a sociedade.” ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Quinze anos tinham se passado desde que Lavinia tinha sido apresentada a sociedade. O cabelo da moda dificilmente poderia compensar os olhos esbugalhados e os dentes tortos de Lavinia, pensou Jane—de forma nada caridosa. \"Nenhum conde poderia ser tão bom quanto o homem que ganhou sua mão.\"")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("\"Claro, você está certa.\" Lavinia suspirou e encolheu os ombros. “Teremos que esperar mais três anos para que nossa Bess seja apresentada. Temos nossas esperanças. Com sua beleza, um duque não está fora de questão.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Rezo para que não encha a cabeça de minha sobrinha com tais ideias. Não queremos que ela se decepcione se não conseguir um casamento com um aristocrata.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("\"Você fala exatamente como Robert.\" ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("O irmão de Jane era extremamente sábio. Mesmo que tivesse escolhido Lavinia como esposa.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("\"Decidi passar um tempo com você\", continuou Lavinia, \"embora eu desaprove veementemente a maneira como você se coloca no canto de trás, fazendo com que toda a "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("alta sociedade")]), _vm._v(" reconheça que nenhum homem a deseja como parceira.\"")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("\"Shh.\" Os olhos de Jane indicaram a Srta. Lambeth. \"Você gostaria que eu atraísse atenção para minha inelegibilidade?\" ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Não precisa anunciar sua inelegibilidade. Você pode não possuir fortuna ou beleza, mas "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("é ")]), _vm._v("neta de um conde. Isso deve contar para alguma coisa.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("A simples menção da ligação de seu marido com um aristocrata tão nobre evocou um sorriso presunçoso no rosto de Lavinia. Ela detestava reconhecer que seu próprio avô tinha sido apenas um cervejeiro. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Jane deu de ombros. \"Tais incentivos não tiveram sucesso, eu temo.\" Secretamente, Jane estava se parabenizando, pois um homem superficial o suficiente para selecionar uma noiva com base na posição de seu avô "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("não")]), _vm._v(" seria um homem com quem ela gostaria de se casar.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Lavínia não lhe deu atenção. \"Você já viu a Srta. Bullen? Seu vestido parece algo que uma cigana enlouquecida usaria!\" ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("\"Shh! Temo que os dançarinos possam lhe ouvir.\" Jane se sentiu impotente para não lançar o olhar para a pista de dança onde a Srta. Bullen, usando um vestido rosa com três fileiras de babados roxos, dançava graciosamente com seu parceiro, alegremente inconsciente de quão verdadeiramente hediondo era seu vestido. Realmente não era justo que ela pudesse merecer um parceiro quando Jane não podia.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("\"Está muito barulhento para alguém prestar a menor atenção ao que estou dizendo.\"")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Então Lavínia fez algo ainda mais imperdoável. Ela apontou para uma jovem corpulenta parada na porta oposta. \"Eu não me importo se Annabelle Sommers tem cinco mil libras por ano, a pobre garota não tem nenhuma condição de conseguir um marido.\"")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("A Srta. Featherstone estava mortificada. \"Eu imploro que você não aponte Lavinia. E, por favor, fale em uma voz mais baixa, embora eu prefira que você não fale mal de ninguém.\" Ela abriu seu leque pintado à mão. Estava ficando excessivamente quente. E ela nem estava dançando! O vestido de Lady Sarah tinha que estar encharcado.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Lavinia e Jane observaram Lady Sarah. Jane não tivera oportunidade de falar com Sarah desde a primeira dança da noite. Os rapazes estavam quase brigando um com o outro, competindo para enfrentar a bela herdeira, obter ratafia "), _c('span', {
    staticStyle: {
      "font-size": "x-small"
    }
  }, [_vm._v("(8)")]), _vm._v(" para ela ou apenas chegar perto o suficiente para ouvir o som melodioso de sua voz. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Se alguém quisesse julgar pela expressão no rosto de Lady Sarah como ela estava se sentindo, veria que ela estava decididamente gostando de seu primeiro baile. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("\"Pelo que sei, os livros de apostas do White's "), _c('span', {
    staticStyle: {
      "font-size": "x-small"
    }
  }, [_vm._v("(9)")]), _vm._v(" estão repletos com o nome de Lady Sarah\", disse Lavinia. \"Há apostas sobre com quem ela vai se casar, bem como em que data o anúncio será feito.\"")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("A Srta. Featherstone não estava ouvindo. Sua atenção estava presa em sua amiga Lady Wycliff. Que mudança havia ocorrido nela desde que tinha se casado! Ela não apenas deixou de ser uma inimiga dos homens antes de se apaixonar por Lord Wycliff, mas também evitava eventos como este, onde ela agora estava dançando com um admirador que não era seu marido. Seus olhares se encontraram, e os de Louisa Wycliff se iluminaram quando a viu. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Assim que a dança acabou, ela voou pela pista de dança para cumprimentar Jane. Louisa Wycliff rivalizava com Lady Sarah em beleza. Ela sempre foi bonita, mas desde que se casou com Lord Wycliff, ficou ainda mais adorável. A melancolia que a caracterizava anteriormente foi substituída por um olhar gentil de felicidade perpétua. Especialmente quando ela estava falando com ou sobre seu marido. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("E as roupas que ela havia adquirido desde o casamento! Ninguém poderia se vestir mais lindamente. Esta noite ela usava um vestido requintado de musselina azul claro que não era mais grosso que uma folha de papiro. Seu corpete e cauda eram bordados com minúsculas flores brancas, e uma coroa de flores brancas adornava seu sedoso cabelo loiro.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("\"Eu não sabia que você participava de tais eventos, Srta. Featherstone.\"")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Jane sorriu. \"Nem eu sabia que você viria.\"")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Lady Wycliff revirou os olhos. \"Lord Spencer é muito importante no governo, e meu querido Harry deseja cortejar seu favor.\" Ela deu de ombros. \"Eu também decidi que, para ajudar nas aspirações políticas de Harry, devo fazer todos os esforços para agir como se tivesse nascido para esse tipo de reunião—que você sabe que não nasci! Decidi deixar a mãe de ele me guiar.\"")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Mas pensei que Lady Wycliff tivesse morrido há alguns anos.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("\"Sim. Mais de uma década—muito antes de eu conhecer Harry, mas a mulher era a perfeição. Quero fazer tudo o que ela fez para que Harry me considere a esposa perfeita.\"")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Uma linda garota loira deu um tapinha no ombro de Sua Senhoria. Ela se virou e sorriu. \"Você não me disse que viria aqui esta noite!\" ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("\"Eu decidi quando Edward me disse que você estaria aqui.\"")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Lady Wycliff se voltou para Jane. \"Você se lembra da minha irmã, a Sra. Coke?\"")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Uma forte semelhança existia entre as duas, apesar da disparidade de idade. A irmã mais nova se casou com o primo de Lord Wycliff ao mesmo tempo em que Lord e Lady Wycliff se casaram. \"Sim, claro, ela é uma de nossas patronesses na terça-feira. Como você está linda esta noite, Sra. Coke.\"")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“É um prazer vê-la aqui, Srta. Featherstone. Detesto roubar Louisa, mas prometi para Lady Soames que a apresentaria a minha irmã.” ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Enquanto Jane observava, as lindas irmãs entravam e saíam da aglomeração em direção à porta. Então ela o viu. Lord Slade entrou no salão de baile. Ele estava acompanhado por um belo oficial militar que Jane reconheceu como seu irmão mais novo. Embora seu irmão aparentasse ser um parceiro de dança ansioso, Lord Slade se moveu para a multidão, então examinou a sala com um olhar de desdém entediado. Devido à sua altura, sua cabeça de cabelo castanho escuro se elevava sobre um mar de cabeças mais pálidas.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Quando ele se aproximou, ela foi capaz de observá-lo em toda sua extensão gloriosa. Esta noite ele não desafiou a moda, mas vestiu-se perfeitamente de preto, exceto pelo linho branco como a neve de sua camisa e a gravata que amarrada abaixo de seu queixo quadrado, combinava com o branco em seus dentes. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Lamentavelmente, seu olhar seguiu Lady Sarah enquanto ela permanecia graciosamente no corredor, com as mãos ligadas aos cavalheiros ao seu lado enquanto observava o casal se mover entre as duas filas de dançarinos. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Agora,”—disse Lavinia, levantando-se – “que Lady Spencer está desacompanhada, devo ir falar com ela.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("\"Sua prima é extremamente popular\", disse a Srta. Lambeth, meio bocejando enquanto falava.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("\"Alguém tão adorável quanto ela não vai demorar muito no Mercado Matrimonial.\"")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("\"Eu ouso dizer que você está certa.\" Com um suspiro, a Srta. Lambeth se levantou. \"É hora de buscar mamãe. Ela se cansa tão facilmente nesses eventos.\" Com isso, a dócil Srta. Lambeth se afastou.  ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Jane odiava tanto que sua amiga fosse embora, pois assim ela ficaria sozinha em seu canto. Seu olhar seguiu a Srta. Lambeth enquanto ela percorria o perímetro da pista de dança. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("\"Boa noite, Srta. Featherstone.\"")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Ela se virou, olhou para cima e viu o belo homem a menos de meio metro de distância, olhando para ela. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("\"Boa noite para você, meu senhor.\" Oh, Deus, ele ia pedir a ela para dançar com ele? Seu coração irreprimível começou a galopar. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("\"Eu imploro que você me permita sentar ao seu lado.\"")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Ela estava quase aliviada por ele não a convidar para dançar. Se alguma dama alguma vez caiu durante a execução dos passos de dança, teria sido a Srta. Featherstone em seu nervosismo por dançar com o homem que ela tanto adorava. “Sinto-me honrada, meu senhor.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Esta noite ele estava tão elegante quanto pareceu descuidado de tarde. Em ambos os casos, pensou Jane, ele era sempre magnífico. Cada aspecto de sua aparência falava de limpeza. A Srta. Featherstone podia até sentir o cheiro de seu sabonete quando ele se sentou ao lado dela.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("\"Diga-me, Srta. Featherstone, você ainda está tão apaixonadamente interessada nos assuntos do governo?\"")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("\"Eu estou, meu senhor.\"")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("\"Senti muita falta daqueles jantares estimulantes em sua casa.\"")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Assim como sentimos sua falta. Atrevo-me a dizer que papai sente ainda mais sua falta como colega na House of Commons.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("\"Só porque me mudei para o aposento superior não significa que eu não ficaria satisfeito em ser incluído entre os convidados de seu pai.\"")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("\"Tenho certeza de que posso falar por papai quando digo que nossa porta estará sempre aberta para você, meu senhor. Na verdade, estamos oferecendo um pequeno jantar amanhã à noite para alguns companheiros Whigs de papai. Ficaríamos extremamente honrados se você viesse.\"")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("\"Sou eu quem ficaria honrado em participar.\" Seus olhos negros encontraram os dela. \"Sinto-me honrado com o convite. Minha filosofia política não mudou de repente porque eu me mudei para a House of Lords "), _c('span', {
    staticStyle: {
      "font-size": "x-small"
    }
  }, [_vm._v("(10)")]), _vm._v(". Sempre serei um Whig.\" ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Ela se lembrou de novo por que começou a admirá-lo tanto. Acima de tudo, ele sempre foi um homem de princípios e altos valores morais. \"Você deve admitir, a maioria de seus companheiros lordes se opõe a tudo que você sempre promulgou.\"")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("\"Isso nunca vai me impedir de continuar trabalhando pela reforma.\" ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("\"Estou muito feliz em ouvir isso, embora, é claro, eu já tivesse presumido isso.\"")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("\"Porque você ainda se mantém bem informada sobre as medidas em ambas as casas?\"")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Ela deu uma risadinha. \"É um dos meus hobbies.\" "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Obsessão, realmente")]), _vm._v(". Mas nenhuma donzela em busca de um companheiro jamais deveria admitir ser uma intelectual.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Ele a favoreceu com seu sorriso cativante. \"E o outro hobby, pelo que me lembro, é executar desenhos arquitetônicos maravilhosos.\"")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("A memória fenomenal do homem continuava a surpreendê-la. \"Não sei se os chamaria de maravilhosos, mas adoro desenhar edifícios clássicos.\"")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("\"Um dia terei que convencê-la a fazer um desenho de Dunvale Castle.\"")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Não preciso ser convencida, meu senhor. Fazer isso me daria grande prazer.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Ele esticou suas longas pernas na frente dele, e parecia que estava contente em ficar ali com ela. Após refletir, ela percebeu que Lord Slade raramente comparecia a essas reuniões, embora ele fosse considerado um dos homens mais elegíveis no reino para ser capturado para um casamento. \"Você não gosta de dançar, Lord Slade?\" ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("\"Dançar e gostar de dançar são dois assuntos completamente diferentes.\"")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Seus olhos brilharam. \"Então parece que estamos de acordo sobre outro assunto.\" Se ele não queria dançar, porém, por que estava aqui?  ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("\"É muito gratificante estar na companhia de alguém que compartilha tantos dos meus ideais\", ele disse. “Na verdade, Srta. Featherstone eu vim aqui esta noite expressamente para vê-la.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("\"Eu, meu senhor?\"")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Ele assentiu. \"Realmente. Há uma pergunta muito importante que devo fazer a você.\"")]), _vm._v(" "), _c('p', {
    staticClass: "section-break"
  }, [_vm._v("––––––––")]), _c('div', {
    staticClass: "decoration-scene-break"
  }, [_c('div', {
    staticClass: "decoration-scene-break-inner"
  }, [_c('img', {
    staticClass: "decoration-scene-break",
    attrs: {
      "alt": "image",
      "src": "d2d_images/scene_break.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first-in-scene",
    staticStyle: {
      "font-size": "x-small",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticClass: "first-scene-phrase"
  }, [_c('span', {
    staticClass: "first-in-scene character-8"
  }, [_vm._v("(8")]), _vm._v(") Ratafia é um termo")]), _vm._v(" amplo usado para dois tipos de bebidas alcoólicas doces, uma essência aromatizante cujo sabor lembra amêndoas amargas, depois um biscoito com sabor de ratafia, um biscoito para ser consumido junto com ratafia, além de uma variedade de cereja.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "x-small",
      "text-align": "justify"
    }
  }, [_vm._v("(9) O White's é o clube de cavalheiros mais antigo de Londres, fundado em 1693, e é considerado por muitos como o clube privado mais exclusivo de Londres.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "x-small",
      "text-align": "justify"
    }
  }, [_vm._v("(10) House of Lords (Câmara dos Lordes) é a câmara alta do parlamento do Reino Unido. O parlamento também inclui a Coroa britânica e a Câmara dos Comuns. A Câmara dos Lordes não tem um número determinado de membros, mas atualmente conta com 792 lordes.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26807838","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/c005.vue
// module id = 72
// module chunks = 0